import {
  QUERY_RESPONSE_RECEIVED,
  MUTATION_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import {
  RADAR_CREATE_SESSIONS,
  RADAR_POLL,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import {
  isFlightsResponseError,
  getFlightsResponseBody,
  isResponseContainFlightsBody,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/flightsResponse';
import keyBy from 'lodash/keyBy';

import { mapRadarPlaces } from './placesMapper';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { PlaceState } from '@web-platform/shared-universal-types/src/redux/state/places/places';

export const INITIAL_STATE: PlaceState = {
  byEntityId: {},
};

const placesReducer = (state: PlaceState = INITIAL_STATE, action: Action): PlaceState => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      if (action.payload.type === RADAR_CREATE_SESSIONS || action.payload.type === RADAR_POLL) {
        if (
          isFlightsResponseError(action.payload.response) ||
          !isResponseContainFlightsBody(action.payload.response)
        ) {
          return state;
        }

        const flightsResponseBody = getFlightsResponseBody(action.payload.response);
        const places = mapRadarPlaces(flightsResponseBody.results || []);

        return {
          byEntityId: { ...state.byEntityId, ...keyBy(places, (place) => place.entity_id) },
        };
      }

      return state;
    }

    default:
      return state;
  }
};

export default placesReducer;
